import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Agreement } from "../../../../shared/models/agreement/agreement";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { AppService } from "../../../../app.service";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";

@Component({
    selector: 'agreement-deadline',
    templateUrl: './agreement-deadline.component.html',
    styleUrls: [
        './agreement-deadline.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class AgreementDeadlineComponent implements OnInit {

    @Input() agreement: Agreement;
    @Input() isReadonly: boolean = false;

    @Output() changeDeadline: EventEmitter<boolean> = new EventEmitter<boolean>();

    defaultMonthName = 'месяцев';
    monthsNames = [
        { name: 'месяц', values: [1, 21, 31] },
        { name: 'месяца', values: [2, 3, 4, 22, 23, 24, 32, 33, 34 ] }];

    durations: KeyValueObject[] = [];
    serviceIntervals: KeyValueObject[] = [];

    public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    oldAgreementDate: Date;
    oldAgreementDuration: number;
    oldAgreementServiceInterval: number;

    constructor(
        private appService: AppService
    ) { }

    ngOnInit(): void {
        this.agreement.agreementDate = this.appService.parseDate(this.agreement.agreementDate);

        this.oldAgreementDate = this.agreement.agreementDate;
        this.oldAgreementDuration = this.agreement.duration;
        this.oldAgreementServiceInterval = this.agreement.serviceInterval;

        let durationMonths = [6, 12, 24];
        let serviceIntervalMonths = [3, 6];

        this.durations = durationMonths.map(x => new KeyValueObject(x, this.generateMonthName(x)));
        this.serviceIntervals = serviceIntervalMonths.map(x => new KeyValueObject(x, this.generateMonthName(x)));
    }

    generateMonthName(num: number): string {
        let nameItem = this.monthsNames.find(x => x.values.some(v => v == num));
        return nameItem != null ? `${num} ${nameItem.name}` : `${num} ${this.defaultMonthName}`;
    }

    changeAgreementDate(value: Date) {
        let wasChanged = this.oldAgreementDate != null && this.oldAgreementDate != value;
        this.changeDeadline.emit(wasChanged);
    }

    changeAgreementDuration(value: number) {
        let wasChanged = this.oldAgreementDuration != null && this.oldAgreementDuration != value;
        this.changeDeadline.emit(wasChanged);
    }

    changeAgreementServiceInterval(value: number) {
        let wasChanged = this.oldAgreementServiceInterval != null && this.oldAgreementServiceInterval != value;
        this.changeDeadline.emit(wasChanged);
    }
}